import { render, staticRenderFns } from "./DocumentacionAduanera.vue?vue&type=template&id=67b3e3ae&"
import script from "./DocumentacionAduanera.vue?vue&type=script&lang=js&"
export * from "./DocumentacionAduanera.vue?vue&type=script&lang=js&"
import style0 from "./DocumentacionAduanera.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports